import { render } from "./Archive.vue?vue&type=template&id=2fa887d2&scoped=true"
import script from "./Archive.vue?vue&type=script&lang=js"
export * from "./Archive.vue?vue&type=script&lang=js"

import "./Archive.vue?vue&type=style&index=0&id=2fa887d2&lang=scss&scoped=true"
import "./Archive.vue?vue&type=style&index=1&id=2fa887d2&lang=scss"

import exportComponent from "/home/runner/work/byb-front/byb-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fa887d2"]])

export default __exports__